import React, { useState, useRef, useEffect, useContext } from "react";
import "./Road.scss";
import "../Button/Button.scss";
import Cars from "../Cars/Cars";
import Lines from "../Lines/Lines"
import Osadniki from "../Osadniki/Osadniki";
import TreesUpper from "../TreesUpper/TreesUpper";
import NotClickable from "../NotClickable/NotClickable";
import { BuildingsContext } from "../../bContext";
import Modal from "../Modal/Modal";
import Instrukcja from "../Instrukcja/Instrukcja";
import useInstrukcja from "../Instrukcja/useInstrukcja";
import useModal from "../Modal/useModal";
import Wycieczka from "../Wycieczka/Wycieczka";
import useWycieczka from "../Wycieczka/useWycieczka";
import objects from "../../objects";
import Sound from "react-sound";
import mainSnd from "../../assets/sounds/music.mp3";
import wodafala from "../../assets/wodafala.gif"

import ooo from "../../assets/ooo.gif"

// import PrismaZoom from "react-prismazoom";
// import { useScrollPosition } from "@n8tb1t/use-scroll-position";
// import { useScroll } from 'react-scroll-hooks';

// import scrollToComponent from "react-scroll-to-component";

function Road(props) {


  // const myRef = useRef(null);

  const {
    checkShowing,
    setCheckShowing,
    which,
    setWhich,
    setModalPage,
    width,
    height,
    bs,
    autoPre,
    musicVol,
    playMusic, 
    pageRoad, setPageRoad, 
    setRepeat,
    wlacz, setwlacz, wlaczOsad, setwlaczOsad,
    switchToEnglish, setSwitchToEnglish,
  } = useContext(BuildingsContext);
 


  const [whichHover, setWhichHover] = useState([]);
  const [whichClicked, setWhichClicked] = useState([]);
  const [exp, setExp] = useState([])
 

  const { isShowing, toggle } = useModal();
  const { showIns, toggleIns } = useInstrukcja();
  const { showWyc, toggleWyc } = useWycieczka();

  const [enPl, setEnPl] = useState(0)

  // console.log(rangeValue);

  useEffect(() => {
    if (autoPre === true && isShowing === false) {
      toggle();
      setWhich(1);
    } else if (autoPre === true && isShowing === true) {
    } else if (autoPre === false && isShowing === true) {
    }
  }, [autoPre, checkShowing, isShowing, setWhich, toggle]);

  useEffect(() => {
    if (isShowing === false) {
      setCheckShowing(false);
    
    } else if (isShowing === true) {
      setCheckShowing(true);
   
    }
  });

  useEffect(() => {
    if(pageRoad === 0) {
      setwlacz(true)
    }else if(pageRoad === 1){
      setwlacz(false)
      const timer = setTimeout(() => setwlacz(true), 10);
       
        return () => clearTimeout(timer);
    }else if (pageRoad === 2){
      setwlacz(false)
    }
  }, [pageRoad, setwlacz])

  useEffect(() => {
    if(pageRoad === 0) {
      setwlaczOsad(true)
    }else if(pageRoad === 2){
      setwlaczOsad(false)
      const timer = setTimeout(() => setwlaczOsad(true), 10);
       
        return () => clearTimeout(timer);
    }else if (pageRoad === 1){
      setwlaczOsad(false)
    }
  }, [pageRoad, setwlaczOsad])

// let Aud = new Audio(mainSnd)

const elms = document.getElementsByClassName("cls-ws");


let n = elms.length;


function changeColor(color) {
    for(let i = 0; i < n; i ++) {
        elms[i].style.fill = color;
    }
}
for(let i = 0; i < n; i ++) {
    elms[i].onmouseover = function() {
        changeColor("rgba(27, 173, 229, 0.6)");
    };
    elms[i].onmouseout = function() {
        changeColor("transparent");
    };
}


const elms2 = document.getElementsByClassName("cls-wt");
let m = elms2.length;

function changeColor2(color) {
  for(let i = 0; i < m; i ++) {
      elms2[i].style.fill = color;
  }
}
for(let i = 0; i < m; i ++) {
  elms2[i].onmouseover = function() {
      changeColor2("rgba(27, 173, 229, 0.6)");
      
  };
  elms2[i].onmouseout = function() {
      changeColor2("transparent");
  };
}




const over = document.getElementsByClassName("cls-1");

// over.onclick = function() {
//   toggle();

// }


for (let i=0; i < over.length; i++) {
  over[i].onclick = function(){
   toggle();
  }
  // over[i].onmouseover = function(){
  //   setExp(whichHover)
  //   console.log(exp)
  //  }
  //  over[i].onmouseout = function(){
  //   setExp()
    
  //  }

}


// console.log(whichHover)


const oczosad = (a,b,c) => {
  if(pageRoad === 1) {
    return `${a} blue_shadow ${b}`
  }else if(pageRoad === 2){
    return `${a} blue_shadow ${c}`
   }else {
    return `${a} blue_shadow`
   }
  
}


  return (
    <>
      <div className="prisma" style={{ minWidth: width, minHeight: height }}>
        <div className="trawka" style={{ width: width, height: height }}>
          <div
            className="road-container"
            style={{ width: width, height: height, backgroundSize: `${bs}px` }}
          >
       
     <Sound
     url={mainSnd}
     playStatus={playMusic ? Sound.status.PLAYING : Sound.status.STOPPED}
    //  onPlaying={() => console.log("plassss")}
     volume={musicVol}
   
   loop

    //   onLoad={() => setPlayD(Sound.status.PLAYING)}
   />
       
 <Lines /> 
          
         
             

            {objects.map((el) => (
              <div
                key={el.id}
                onClick={() => {
                  // toggle();
                  setWhich(el.id);
                  setWhichClicked(switchToEnglish === false ? el.title : el.titleEn);
                  setRepeat(Sound.status.PLAYING)
                }}
                onMouseOver={() => setWhichHover(switchToEnglish === false ? el.title : el.titleEn)}
                onMouseLeave={() => setWhichHover()}
                
                className={oczosad(el.class, el.oczop,el.osadop )}
              >
                <img
                key={`${el.id}ass`}
                  id={el.id}
                  src={el.model}
                  alt={switchToEnglish === false ? el.title : el.titleEn}
                  title={switchToEnglish === false ? el.title : el.titleEn}
                />
             
                {el.model_shape}
                
                {el.spinBr && el.spinBr.map((el) => (
                  <>
                 {el.spin[0] &&  <img key={`${el.id}assa`} className={el.classSpin[0]} src={el.spin[0]} alt="" />}
                { el.spin[1] &&  <img key={`${el.id}assb`} className={el.classSpin[1]} src={el.spin[1]} alt="" />}
                { el.spin[2] &&  <img key={`${el.id}assc`} className={el.classSpin[2]} src={el.spin[2]} alt="" />}
                { el.spin[3] &&  <img key={`${el.id}assd`} className={el.classSpin[3]} src={el.spin[3]} alt="" />}
                 {el.spin[4] &&  <img  key={`${el.id}asse`} className={el.classSpin[4]} src={el.spin[4]} alt="" />}
                 </>
                ))}
                {el.flames && <img key={`${el.id}xxa`} className="pochodnia-flames" src={el.flames} alt="" />}
                {el.water && <img key={`${el.id}xxb`} className="wodaosad" src={el.water} alt="" /> }
                {el.water && <img key={`${el.id}xxc`} className="wodaosad2" src={el.water} alt="" /> }
                {el.water && <img key={`${el.id}xxd`} className="wodaosad3" src={el.water} alt="" /> }
                {el.water && <img key={`${el.id}xxe`} className="wodaosad4" src={el.water} alt="" /> }

                {el.piaskownikAnime && <img key={`${el.id}xxz`} className="piaskownikAnime" src={el.piaskownikAnime} alt="" /> }
          
              </div>
            ))}
            {/* <img className="gify" src={ooo} alt="" /> */}
            <Cars />
            <Osadniki />
            <TreesUpper />
            <NotClickable />
            {/* 
            <button onMouseDown={toggle} style={{width: "20rem", height: "20rem"}}></button> */}
            <Modal isShowing={isShowing} hide={toggle} />
            <Instrukcja isShowing={showIns} hide={toggleIns} />
            <Wycieczka isShowing={showWyc} hide={toggleWyc} />

          </div>
        </div>

        {/*=========================================window display ================================== */}
        <div className="text-disp-cont">
          <div className="text-display">
            {isShowing ? (
              objects.map(
                (el) => el.id === which && <p key={el.id}>{switchToEnglish === false ? el.title : el.titleEn}</p>
              )
            ) : (
              <p>{whichHover}</p>
            )}
            {}
          </div>
        </div>

        {/*=========================================window display ================================== */}
        <div className="nav-btn">
          <div className="glowna">
            <div
              className={pageRoad === 0 ? "button-big active" : "button-big"}
              onClick={() => {
                setPageRoad(0);
              }}
            >
              <span
                className={
                  pageRoad === 0 ? "button-small active" : "button-small"
                }
              >
                {switchToEnglish === false ?  "STRONA GŁÓWNA" : "HOME PAGE"}
              </span>
            </div>
          </div>
          <div className="oczyszczalnia">
            <div
              className={pageRoad === 1 ? "button-big active" : "button-big"}
              onClick={() => {
                setPageRoad(1);
              }}
            >
              <span
                className={
                  pageRoad === 1 ? "button-small active" : "button-small"
                }
              >
                {switchToEnglish === false ?  "OCZYSZCZALNIA" : "TREATMENT PLANT"}
              </span>
            </div>
          </div>
          <div className="osad">
            <div
              className={pageRoad === 2 ? "button-big active" : "button-big"}
              onClick={() => {
                setPageRoad(2);
              }}
            >
              <span
                className={
                  pageRoad === 2 ? "button-small active" : "button-small"
                }
              >
                {switchToEnglish === false ?  "OSAD CZYNNY" : "ACTIVE SEDIMENT"}
               
              </span>
            </div>
          </div>
          <div className="wycieczka">
            <div
              className={pageRoad === 3 ? "button-big active" : "button-big"}
              onClick={() => {
                setPageRoad(3);
                toggleWyc();
              }}
            >
              <span
                className={
                  pageRoad === 3 ? "button-small active" : "button-small"
                }
              >
                {switchToEnglish === false ?  "WYCIECZKA" : "EXCURSION"}
              
              </span>
            </div>
          </div>

          <div className="plen">
        <div className={switchToEnglish === false ? "button-big5en active2" : "button-big5en"}
        onClick={() => setSwitchToEnglish(false)}
        >
          <span className={switchToEnglish === false ? "button-small5en active2" : "button-small5en"}>PL</span>
        </div>
         <div className={switchToEnglish === true ? "button-big5en active2" : "button-big5en"}
         onClick={() => setSwitchToEnglish(true)}>
          <span className={switchToEnglish === true ? "button-small5en active2" : "button-small5en"} >EN</span>
        </div>
      </div>

        </div>
        <div className="grid-container">
          <div className="instrukcja">
            <div
              className={pageRoad === 4 ? "button-big active" : "button-big"}
              onClick={() => {
                setPageRoad(4);
                setModalPage(1);
                toggleIns();
              }}
            >
              <span
                className={
                  pageRoad === 4 ? "button-small active" : "button-small"
                }
              >
                {switchToEnglish === false ?  "INSTRUKCJA" : "INSTRUCTION"}
                
              </span>
            </div>
          </div>
        </div>

        {/* {volView && (
          <div className="vol-slider">
            <input type="range" />
          </div>
        )} */}
      </div>
    </>
  );
}

export default Road;
